import paymentMethod from "./paymentMethod.component";
import paymentMethodUrls from "./paymentMethod.urls";
import PaymentMethodTransforms from "./paymentMethod.transforms";

const paymentMethodModule = angular
  .module("app.components.paymentMethod", [])
  .component("paymentMethodPage", paymentMethod)
  .service("PaymentMethodTransforms", PaymentMethodTransforms)
  .config(paymentMethodUrls);

export default paymentMethodModule;



// WEBPACK FOOTER //
// ./src/pages/paymentMethod/paymentMethod.module.js